import { store } from "../../../../..";
import {
    clubhouseActions,
    selectLeague,
} from "../../../../../features/clubhouse/clubhouseSlice";
import {
    leagueManagementActions,
    selectLeagues,
} from "../../../../../features/leaguemgmt/leagueManagementSlice";

export const loader = async ({ params }: any) => {
    const teamId = parseInt(params.teamId);
    let leagues = selectLeagues(store.getState());

    if (!leagues.length) {
        await store.dispatch(leagueManagementActions.getLeagues());
        leagues = selectLeagues(store.getState());
    }

    const league = leagues.find(l =>
        l.teams ? l.teams.some(t => t.id === teamId) : false,
    );

    if (!league || league.id !== selectLeague(store.getState())?.id) {
        store.dispatch(clubhouseActions.setLeague(league));
    }

    return {
        teamId,
    };
};

export default loader;
